import { useStore } from "./store";
import { initWsgenv as initWsgsdk, initSCG } from "@didi/wsgsdk-corejs3";

let wsgInstance: {
  wsgParams: (
    params1: {
      url: string;
    },
    params2: (wsgenv: TWsgenvObj) => void
  ) => void;
};

export const initWsgenvInstance = () => {
  if (initWsgsdk) {
    wsgInstance = initWsgsdk({
      appId: "06040705",
      env: "AME",
      wsgenvEnv: "single",
    });
  }
  return true;
};
initWsgenvInstance();


type TWsgenvObj = {
  data: string;
};

/**
 * 根据接口获取wsgenv
 * @param api 接口名
 */
export const initWsgenv = (api: string) => {
  if(wsgInstance){
    const prodctionUrl = `${window.location.origin}${process.env['VUE_APP_API_GATEWAY']}${api}`
    const url = process.env["VUE_APP_ENV"] === 'production'
        ? prodctionUrl : "https://manhattan-app.didiglobal.com/gateway/baldr/api/contract/externalSignContract"
    // console.log('url: ', url);
    const params = {
      url,
    };
    // 调用实例对象的wsgParams方法获取wsgenv
    wsgInstance.wsgParams(params, function (wsgenv: TWsgenvObj) {
      // SDK 回调在部分场景返回对象字符串，统一转成对象后取 data
      let snapshot: Record<string, any> = {}
      try {
        const serialized = JSON.stringify(wsgenv || {})
        const parsed = JSON.parse(serialized)
        snapshot =
          typeof parsed === 'string'
            ? JSON.parse(parsed)
            : parsed
      } catch (e) {
        // ignore snapshot parse error, fallback to direct field access
      }
      const snapData = snapshot?.['data']
      const bizSystemInfo =
        typeof snapData === 'string' ? snapData : ''
      
      // 此处拿到wsgenv后再自行通过接口上报
      if (bizSystemInfo) {
        const appStore = useStore() || window.$store
        appStore?.commit("native/saveBizSystemInfo", bizSystemInfo);
      }
    });
  }
};

export const initWsg = () => {
  initSCG({
    // 挑战应答参数
    domainList: [
      'manhattan-app.didiglobal.com',
      'dsim526-api.intra.xiaojukeji.com',
      'pre.global.manhattan.app.intra.xiaojukeji.com',
      'sofipo-app.didifinance.com',
        'sofipo-pre.intra.didifinance.com'
    ],
    // 签名能力相关参数
    env: "ame",
    bizId: "fe76c4528d712db2ce5ce33cf9edbf91",
    appVer: "v0.0.1",
    os: "4",
  });
};
